import { toast } from "react-toastify";

import FormTextField from "@/components/UI/FormTextField";
import { ExperienceService } from "@/services";
import { validateExperienceTitle } from "@/utils/validator";
import { isPublicPage } from "@/utils/visualBuilder";

export default function ShareTitleField(props) {
  const {
    classes,
    control,
    errors,
    getValues,
    propertyId,
    experienceId,
    experience,
    tabStatus,
    handleShareChange,
    handleFocus,
    handleBlur,
  } = props;

  const handleSubmitTitle = async () => {
    const title = getValues("title");
    if (errors.title) return;

    // If no change, do nothing
    if (title === experience.title) return;

    let newTitle = title || "Untitled";
    try {
      await ExperienceService.updateExperience(propertyId, experienceId, { title: newTitle });
      handleShareChange(newTitle);
    } catch (err) {
      toast.error(`Failed to update experience title: ${err.message}`);
    }
  };

  const handleTitleBlur = async () => {
    const title = getValues("title");
    const [error] = validateExperienceTitle(title);

    handleBlur();

    if (!error) {
      await handleSubmitTitle();
    }
  };

  const isDisabled = isPublicPage(tabStatus) || !experienceId;

  return (
    <div className={classes.formControl} data-testid="share-title-field-container">
      <FormTextField
        name="title"
        label="Experience Title"
        variant="standard"
        fullWidth
        hideCloseIcon={isDisabled}
        control={control}
        classes={{ root: classes.textField }}
        onBlur={() => experienceId && handleTitleBlur()}
        disabled={isDisabled}
        onFocus={handleFocus}
      />
    </div>
  );
}
